import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetEmpresasResp, ISetEmpresaReq } from "@p-parametria/mantenimiento/abc-empresas/interfaces/IABCEmpresas";
import {
    IGetCampoNuevoReq,
    IGetCampoNuevoRes,
    IGetCamposReq,
    IGetCamposRes,
    IGetTablasCampoReq,
    IGetTablasCampoRes,
} from "@p-parametria/mantenimiento/abc-empresas/interfaces/ICustomizables";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IGetCuentasReq, IGetCuentasRes } from "../interfaces/ICuentas";
import { 
    IGetSucursalesReq, 
    IGetSucursalesResp,
    IGetCiudadesReq,
    IGetCiudadesResp,
    ICreateSucursalReq,
    ICreateSucursalResp
} from "../interfaces/ISucursales";
import { 
    IGetPromocionesReq, 
    IGetPromocionesResp,
    IGetPromocionaut6Req,
    IGetPromocionaut6Resp,
    IGetAllPromocionesReq,
    IGetAllPromocionesResp,
    IDeletePromocionReq,
    IDeletePromocionResp
} from "../interfaces/IPromociones";
import { ICreatePromocionReq, ICreatePromocionResp } from "../interfaces/IPromociones";

export interface IGetOpcionesEmpresaRequest {
  tope: string;
  sCampo: string;
  sTabla: string;
}

export interface IOpcionEmpresa {
  sCampo: string;
  sTabla: string;
  sOpcion: string;
}

export interface IGetOpcionesEmpresaResponse {
  data: IOpcionEmpresa[];
}

@Injectable({
    providedIn: "root",
})
export class EmpresasService {
    constructor(private http: HttpClient) {}

    GetEmpresas(): Observable<any> {
        return this.http.post<GetEmpresasResp>(environment.apiNewBackBaseUrl + "GtEmpresas/GetEmpresas", {});
    }

    GetEmpresaXClave(clave: string): Observable<any> {
        // En Desuso Por que la tabla de primeng cumple la misma funcionalidad
        const payload: ISetEmpresaReq = {
            tope: "",
            cmd: "",
            sEmpresa: clave,
            sNombre: "",
            cuentacontable: "",
            responsable: "",
            calle: "",
            colonia: "",
            ciudad: "",
            del_mun: "",
            cve_estado: "",
            cp: 0,
            telefono: "",
            stipo: "",
        };
        return this.http.post<any>(environment.apiNewBackBaseUrl + "GtEmpresas/GetEmpresaXClave/", payload);
    }

    GetEstados(): Observable<any> {
        return this.http.get<any>(environment.apiNewBackBaseUrl + "OpcionesEmpresa/GetEstado");
    }

    GetTipos(): Observable<any> {
        return this.http.get<any>(environment.apiNewBackBaseUrl + "OpcionesEmpresa/GetTipo");
    }
    SetEmpresa(data: ISetEmpresaReq): Observable<ISetEmpresaReq> {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "GtEmpresas/CreateEmpresa", data);
    }

    UpdateEmpresa(data: ISetEmpresaReq): Observable<ISetEmpresaReq> {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "GtEmpresas/UpdateEmpresa", data);
    }

    DeleteEmpresa(clave: string): Observable<any> {
        const payload: ISetEmpresaReq = {
            tope: "",
            cmd: "",
            sEmpresa: clave,
            sNombre: "",
            cuentacontable: "",
            responsable: "",
            calle: "",
            colonia: "",
            ciudad: "",
            del_mun: "",
            cve_estado: "",
            cp: 0,
            telefono: "",
            stipo: "",
        };
        return this.http.post<any>(environment.apiNewBackBaseUrl + "GtEmpresas/DeleteEmpresa", payload);
    }

    // SERVICIO CUSTOMIZABLES
    GetCampos(payload: IGetCamposReq) {
        return this.http.post<IGetCamposRes>(environment.apiNewBackBaseUrl + "CustomEmpresa/GetCampos", payload);
    }

    GetTablasCampo(payload: IGetTablasCampoReq) {
        return this.http.post<IGetTablasCampoRes>(environment.apiNewBackBaseUrl + "CustomEmpresa/GetTablasCampo", payload);
    }

    GetCampoNuevo(payload: IGetCampoNuevoReq) {
        return this.http.post<IGetCampoNuevoRes>(environment.apiNewBackBaseUrl + "CustomEmpresa/GetCampoNuevo", payload);
    }

    EditCampos(payload: IGetCamposReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "CustomEmpresa/EditCampo", payload);
    }

    DeleteCampos(payload: IGetCamposReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "CustomEmpresa/DeleteCampo", payload);
    }

    // SERVICIOS PARA CUENTAS
    GetCuentas(payload: IGetCuentasReq) {
        return this.http.post<IGetCuentasRes>(environment.apiNewBackBaseUrl + "Cuenta/GetCuentas", payload);
    }

    CreateCuenta(payload: IGetCuentasReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Cuenta/CreateCuenta", payload);
    }

    EditCuenta(payload: IGetCuentasReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Cuenta/EditCuenta", payload);
    }

    DeleteCuenta(payload: IGetCuentasReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Cuenta/DeleteCuenta", payload);
    }

    GetSucursales(clave: string): Observable<IGetSucursalesResp> {
        const payload: IGetSucursalesReq = {
            que: 4,
            tope: "9999",
            cmd: "",
            clave,
            cve_sucursal: "",
            nombre_sucursal: "",
            ciudad: ""
        };
        return this.http.post<IGetSucursalesResp>(
            environment.apiNewBackBaseUrl + "GetMnto/GetMntoEmpresaSuc",
            payload
        );
    }

    GetSucursalCiudad(sUsuario: string): Observable<IGetCiudadesResp> {
        const payload: IGetCiudadesReq = {
            sUsuario
        };
        return this.http.post<IGetCiudadesResp>(
            environment.apiNewBackBaseUrl + "GtEmpresas/GetSucursalCiudad",
            payload
        );
    }

    CreateSucursal(data: ICreateSucursalReq): Observable<ICreateSucursalResp> {
        return this.http.post<ICreateSucursalResp>(
            environment.apiNewBackBaseUrl + "GtEmpresas/PostNewSucursal",
            data
        );
    }

    // SERVICIOS PARA PROMOCIONES
    GetPromocionaut4(payload: IGetPromocionesReq): Observable<IGetPromocionesResp> {
        return this.http.post<IGetPromocionesResp>(
            environment.apiNewBackBaseUrl + "Promociones/GetPromocionaut4",
            payload
        );
    }

    GetPromocionaut6(payload: IGetPromocionaut6Req): Observable<IGetPromocionaut6Resp> {
        return this.http.post<IGetPromocionaut6Resp>(
            environment.apiNewBackBaseUrl + "Promociones/GetPromocionaut6",
            payload
        );
    }

    GetAllPromociones(payload: IGetAllPromocionesReq): Observable<IGetAllPromocionesResp> {
        return this.http.post<IGetAllPromocionesResp>(
            environment.apiNewBackBaseUrl + "Promociones/GetAll",
            payload
        );
    }

    DeletePromocion(payload: IDeletePromocionReq): Observable<IDeletePromocionResp> {
        return this.http.post<IDeletePromocionResp>(
            environment.apiNewBackBaseUrl + "Promociones/GetPromocionaut3",
            payload
        );
    }

    CreatePromocion(payload: ICreatePromocionReq): Observable<ICreatePromocionResp> {
        return this.http.post<ICreatePromocionResp>(
            environment.apiNewBackBaseUrl + "Promociones/GetPromocionaut3",
            payload
        );
    }

    GetOpcionesEmpresa(payload: IGetOpcionesEmpresaRequest): Observable<IGetOpcionesEmpresaResponse> {
        return this.http.post<IGetOpcionesEmpresaResponse>(
            `${environment.apiNewBackBaseUrl}OpcionesEmpresa/Getopcnvostablas`,
            payload
        );
    }
}
